import Profile from '../components/User/Profile.vue'
import AcceptTerms from '../components/Auth/AcceptTerms.vue'

let routes = {
    path: '/profile',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/profile',
            name: 'Profile',
            component: Profile,
            meta: {
              title: "Perfil",
              breadcrumb: `<li><a href="/"><i class="ti-home"></i> Dashboard </a></li><li><a href="/"><i class="ti-user"></i> Profile</a></li>`
            }
        },
        {
            path: '/profile/accept_terms',
            name: 'Politica de utilização dos veículos da frota',
            component: AcceptTerms,
            meta: {
              title: "Perfil",
              breadcrumb: `<li><a href="/"><i class="ti-home"></i> Dashboard </a></li><li><a href="/"><i class="ti-user"></i> Profile</a></li>`
            }
        }
    ]
}


export default routes



// WEBPACK FOOTER //
// ./src/router/profile.js